<template>
    <div class="set-goals">
        <b-navbar class="px-2" toggleable="md" type="dark" variant="primary">
            <b-navbar-brand href="#">Set Provider Goals</b-navbar-brand>
            <b-navbar-toggle class="ml-auto" target="nav_collapse3"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse3">
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item href="#">
                <button type="button" id="close-tooltip" class="btn mr-xs btn-default btn-sm" @click="closeSlideOutPanel"><i class="la la-remove"></i></button>
                <b-tooltip target="close-tooltip" triggers="hover">
                    Close
                </b-tooltip>
                </b-nav-item>                
            </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <b-overlay :show="overlayshow" rounded="sm">
            <b-container fluid>            
                <PopupErrorDisplay/>
                <b-row>
                    <b-col>
                        <Widget
                        class=""                    
                        customHeader
                        >
                            <div class="text-section last-section mt-3 mb-3 providers-production-section">                  
                                <div class="table-resposive disable">
                                    <h3 class="fw-semi-bold sec_header">Office Goals</h3>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Setting</th>
                                                <th>Value</th>                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span class="">Monthly Net Production</span>                                                
                                                </td>
                                                <td>                                                
                                                    <b-form-input placeholder="0" type="number" v-model.number="monthlyNetProduction"></b-form-input>                                                
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span class="">Monthly Collection</span>                                                
                                                </td>
                                                <td>                                                
                                                    <b-form-input placeholder="0" type="number" v-model.number="monthlyCollection"></b-form-input>                                                
                                                </td>
                                            </tr> 
                                            <tr>
                                                <td>
                                                    <span class="">Monthly New Patients</span>                                                
                                                </td>
                                                <td>                                                
                                                    <b-form-input placeholder="0" type="number" v-model.number="monthlyNewPatients"></b-form-input>                                                
                                                </td>
                                            </tr> 
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="text-section last-section mt-3 mb-3 providers-production-section">                  
                                <div class="table-resposive disable">
                                    <h3 class="fw-semi-bold sec_header">Providers Production Goals</h3>
                                    <table class="table" v-if="providerGoals">
                                        <thead>
                                            <tr>
                                                <th>Select Provider</th>
                                                <th>Monday</th>
                                                <th>Tuesday</th>
                                                <th>Wednesday</th>
                                                <th>Thursday</th>
                                                <th>Friday</th>
                                                <th>Saturday</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(provider, index) in providerGoals" :key="index">
                                                <td>
                                                    <span class="mobile-display">Select provider</span>                                                
                                                    <select class="custom-select" style="max-width:100%;" disabled>
                                                        <option value="All">{{getProviderName(provider.ProvNum)}} <span class="small">({{provider.Abbr}})</span></option>                                            
                                                    </select>
                                                </td>
                                                <td v-for="n in 6" :key="n">
                                                    <span class="mobile-display">Net Production Goal</span>
                                                    <b-form-input placeholder="$0" type="number" v-model.number="provider.ProductionGoal[n]"></b-form-input>
                                                    <!-- <b-form-input placeholder="$0" type="number" v-model.number="getProvider"></b-form-input> -->
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- 
                                        <button type="button" disabled class="btn mb-xs mr-xs btn-default" @click="addMore">+ Add More</button>
                                    -->
                                    
                                </div>
                            </div>

                            <div class="text-section last-section mt-3 mb-3 providers-production-section">
                                <div class="table-resposive disable">
                                    <h3 class="fw-semi-bold sec_header">Provider Lunch Duration</h3>
                                    <p class="text-muted small">Configure lunch break duration for each provider. Used to calculate $/hour production metrics. A provider with no lunch set (0 minutes) has nothing deducted, so set each provider's lunch for each day they take one.</p>
                                    <table class="table" v-if="providerLunchDuration">
                                        <thead>
                                            <tr>
                                                <th>Provider</th>
                                                <th>Lunch (min)</th>
                                                <th class="text-center">M</th>
                                                <th class="text-center">T</th>
                                                <th class="text-center">W</th>
                                                <th class="text-center">Th</th>
                                                <th class="text-center">F</th>
                                                <th class="text-center">S</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(provider, index) in providerLunchDuration" :key="'lunch-' + index">
                                                <td>
                                                    <select class="custom-select" style="max-width:100%;" disabled>
                                                        <option value="All">{{getProviderName(provider.ProvNum)}} <span class="small">({{provider.Abbr}})</span></option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <b-form-input
                                                        placeholder="0"
                                                        type="number"
                                                        v-model.number="provider.LunchMinutes"
                                                        style="width: 80px;"
                                                        min="0"
                                                        max="120"
                                                    ></b-form-input>
                                                </td>
                                                <td class="text-center">
                                                    <b-form-checkbox v-model="provider.ApplyTo[1]"></b-form-checkbox>
                                                </td>
                                                <td class="text-center">
                                                    <b-form-checkbox v-model="provider.ApplyTo[2]"></b-form-checkbox>
                                                </td>
                                                <td class="text-center">
                                                    <b-form-checkbox v-model="provider.ApplyTo[3]"></b-form-checkbox>
                                                </td>
                                                <td class="text-center">
                                                    <b-form-checkbox v-model="provider.ApplyTo[4]"></b-form-checkbox>
                                                </td>
                                                <td class="text-center">
                                                    <b-form-checkbox v-model="provider.ApplyTo[5]"></b-form-checkbox>
                                                </td>
                                                <td class="text-center">
                                                    <b-form-checkbox v-model="provider.ApplyTo[6]"></b-form-checkbox>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="text-section last-section mt-3 mb-3 providers-production-section">
                                <div class="table-resposive disable">
                                    <h3 class="fw-semi-bold sec_header">Procedures Tracking</h3>
                                </div>
                            </div>

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Select Proc Codes</th>
                                        <th>Monthly Goal</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(procTracking, index) in proceduresTracking" :key="index">
                                        <td>
                                            <span class="mobile-display">Proc Codes</span>
                                            <multiselect
                                                v-if="procCodes"
                                                v-model="procTracking.procCode"
                                                :options="procCodes"
                                                :multiple="false"
                                                :taggable="false"
                                                :show-labels="false"                                            
                                                label="ProcCode"
                                                track-by="ProcCode"
                                                aria-placeholder="Add Options"                                            
                                                ></multiselect>
                                        </td>
                                        <td>
                                            <b-form-input placeholder="" type="number" v-model.number="procTracking.monthlyGoal"></b-form-input>
                                        </td>
                                        <td>                                
                                            <span class="glyphicon glyphicon-trash" @click="selectedProcTrackingIndex=index;showModal('delProcTracking')"/>                                    
                                        </td>
                                    </tr>
                                    <a href="#" id="addProcCodeToProcedureTracking" class="ml-2" @click="addProcCodeToProcedureTracking">Add more</a>
                                </tbody>
                            </table>
                            <b-button variant="success" type="submit" class="btn-sm mt-2 ml-2" @click="save">Save</b-button>
                            <b-button variant="success" type="submit" class="btn-sm mt-2 ml-2" @click="setErrored2(false);setMessage2('');$emit('closePanel', {});">Cancel</b-button>
                        </Widget>
                    </b-col>
                </b-row>
            </b-container> 
        </b-overlay>       

        <b-modal ref="delProcTracking" id="delete" title="Delete" body-class="bg-white">
            <p>Are you sure you want to to delete this entry?</p>
            <div slot="modal-footer" class="w-100">
            <b-button variant="danger" size="sm" class="float-right" @click="hideModal('delProcTracking')">No</b-button>
            <b-button variant="success" size="sm" class="float-right mr-3" @click="deleteProcCodeTracking">Yes</b-button>
            </div>
        </b-modal>

        
    </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue';
import Widget from '@/components/Widget/Widget';
import mixin from '../../../mixin.js';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import _ from 'lodash';
import Multiselect from "vue-multiselect";
import PopupErrorDisplay from "@/components/ErrorDisplay/PopupErrorDisplay";

export default {
    name: 'SetProviderGoals',
    components: {Widget, Multiselect, PopupErrorDisplay},    
    mixins: [mixin],

    async created() {
        await this.init();
    },

    data(){
        return {
            overlayshow: false,
            loadingStatus: false,
            goals: [],
            providerGoals: [],
            providerLunchDuration: [],
            selected: {},
            monthlyNetProduction: 0,
            monthlyCollection: 0,
            monthlyNewPatients: 0,
            proceduresTracking: [],
            selectedProcTrackingIndex: null,
        }
    },

    methods: {

        ...mapActions('customer', ['getProcCodes']),
        ...mapActions('huddle', ['getHuddleDetailsData', 'saveGoals', 'getGoals']),

        async init() {
            this.overlayshow = !this.overlayshow;
            this.resetError();
            let payload = {
                siteID: this.siteID
            };
            //console.log(JSON.stringify(payload, null, 4));

            try {
                if(!this.procCodes)
                    await this.getProcCodes({siteID: this.siteID});
                let res = await this.getGoals(payload);
                //console.dir(res);
                if(res.data[0] && res.data[0].PropertyValue) {
                    this.goals = JSON.parse(res.data[0].PropertyValue);
                    this.monthlyNetProduction = this.goals.monthlyNetProduction ? this.goals.monthlyNetProduction : 0,
                    this.monthlyCollection = this.goals.monthlyCollection ? this.goals.monthlyCollection : 0;
                    this.monthlyNewPatients = this.goals.monthlyNewPatients ? this.goals.monthlyNewPatients: 0;
                    this.proceduresTracking = this.goals.proceduresTracking ? this.goals.proceduresTracking : [];

                    // below was done to do backward compatibility when 3 extra setting wasn't introduced
                    let savedProviderGoals = this.goals.providerGoals ? this.goals.providerGoals : this.goals;

                    // Only display providers that are currently active (not hidden in Open Dental), and dedup old saved data
                    this.providerGoals = _.uniqBy(savedProviderGoals.filter(g => this.providers.some(p => p.ProvNum === g.ProvNum)), 'ProvNum');

                    // Add any new providers that have been added since goals were last saved
                    let newProviders = _.differenceWith(this.providers, savedProviderGoals, (p,g) => p.ProvNum === g.ProvNum);
                    for(const p of newProviders) {
                        let o = {
                            ProvNum: p.ProvNum,
                            Abbr: p.Abbr,
                            ProductionGoal: {}
                        }
                        this.providerGoals.push(o);
                    }

                    // Load provider lunch duration settings
                    let savedLunchDuration = this.goals.providerLunchDuration ? this.goals.providerLunchDuration : [];

                    // Only display providers that are currently active (not hidden in Open Dental), and dedup old saved data
                    this.providerLunchDuration = _.uniqBy(savedLunchDuration.filter(g => this.providers.some(p => p.ProvNum === g.ProvNum)), 'ProvNum');

                    // Add any new providers that don't have lunch settings yet
                    let newProvidersForLunch = _.differenceWith(this.providers, savedLunchDuration, (p,g) => p.ProvNum === g.ProvNum);
                    for(const p of newProvidersForLunch) {
                        let o = {
                            ProvNum: p.ProvNum,
                            Abbr: p.Abbr,
                            LunchMinutes: 0,
                            ApplyTo: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: false }
                        }
                        this.providerLunchDuration.push(o);
                    }
                } else {
                    // No initial settings found. Let's add empty data
                    for(const p of this.providers) {
                        let o = {
                            ProvNum: p.ProvNum,
                            Abbr: p.Abbr,
                            ProductionGoal: {}
                        }
                        this.providerGoals.push(o);

                        // Initialize lunch duration for each provider
                        let lunchObj = {
                            ProvNum: p.ProvNum,
                            Abbr: p.Abbr,
                            LunchMinutes: 0,
                            ApplyTo: { 1: true, 2: true, 3: true, 4: true, 5: true, 6: false }
                        }
                        this.providerLunchDuration.push(lunchObj);
                    }
                }

                this.overlayshow = !this.overlayshow;
                
            } catch (error) {
                this.overlayshow = !this.overlayshow;
                this.$toast.error(error);                
            }
            
        },

        async closeSlideOutPanel() {          
          this.$emit('closePanel',this.goals);
        },

        async save() {
            this.overlayshow = !this.overlayshow;
            this.goals = {
                providerGoals: this.providerGoals,
                providerLunchDuration: this.providerLunchDuration,
                monthlyNetProduction: this.monthlyNetProduction,
                monthlyCollection: this.monthlyCollection,
                monthlyNewPatients: this.monthlyNewPatients,
                proceduresTracking: this.proceduresTracking
            };

            let payload = {
                siteID: this.siteID,
                goals : this.goals
            }
            try {
                await this.saveGoals(payload);
                this.$emit('closePanel',this.goals);  
                this.$toast.success("Huddle goals saved successfully!");
                this.overlayshow = !this.overlayshow;
            } catch (error) {
                this.overlayshow = !this.overlayshow;  
                this.$toast.error(error);
            }            
        },

        addProcCodeToProcedureTracking() {
            let temp = this.proceduresTracking;
            let temp1 = {
                procCode: [],
                monthlyGoal: ''
            }
            temp.push(temp1);            
            Vue.set(this, 'proceduresTracking', temp);
        },

        getProvider(provNum) {
            return this.providerGoals.find(p => p.ProvNum === provNum);
        },

        deleteProcCodeTracking() {
            this.proceduresTracking.splice(this.selectedProcTrackingIndex, 1);
            this.hideModal('delProcTracking');
        },
    },

    computed: {
        ...mapState({        
            procCodes: state => state.customer.procCodes
        }),

        dataToDisplay() {
            if(this.results && this.results.data && this.results.data.length > 0)
                return this.results.data;
        },

        goal: {
            get: function (provNum, dayNum) {
                let a = this.providerGoals.find(p => p.ProvNum === provNum);
                if(a) {
                    return a.ProviderGoals[dayNum];
                }
            },
            set: function (newValue) {
                let a = this.providerGoals.find(p => p.ProvNum === provNum);
                if(a) {
                    return a.ProviderGoals[dayNum];
                }
            }
        },
    }
}

</script>

<style src="./HuddleComponentsModern.scss" lang="scss" />